import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import EmojiPicker from "@/components/EmojiPicker";

export const CATEGORIES = [
    "Internal Audit Roles and Responsibilities",
    "Risk Management Governance",
    "Risk Management Assurance",
    "Mixed",
];

export default function SetDialog({ open, onOpenChange, initial, onSubmit, title = "Study set" }) {
    const [name, setName] = useState("");
    const [emoji, setEmoji] = useState("📚");
    const [category, setCategory] = useState("__none__");

    useEffect(() => {
        if (open) {
            setName(initial?.name || "");
            setEmoji(initial?.emoji || "📚");
            setCategory(initial?.category || "__none__");
        }
    }, [open, initial]);

    const submit = () => {
        if (!name.trim()) return;
        onSubmit({
            name: name.trim(),
            emoji: emoji || "📚",
            category: category === "__none__" ? "" : category,
        });
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="set-dialog">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label>Name</Label>
                        <div className="mt-2 flex gap-2">
                            <EmojiPicker value={emoji} onChange={setEmoji} testid="set-dialog-emoji" />
                            <Input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="e.g. Weak spots · Domain 2"
                                autoFocus
                                data-testid="set-dialog-name"
                            />
                        </div>
                    </div>
                    <div>
                        <Label>Category</Label>
                        <Select value={category} onValueChange={setCategory}>
                            <SelectTrigger className="mt-2" data-testid="set-dialog-category"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="__none__">— No category —</SelectItem>
                                {CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
                            </SelectContent>
                        </Select>
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
                    <Button
                        onClick={submit}
                        disabled={!name.trim()}
                        className="bg-primary text-primary-foreground hover:bg-primary/90"
                        data-testid="set-dialog-submit"
                    >
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
